import React from 'react';
import ConnectAmazonAccount from './ConnectAmazonAccount';
import ConnectShopifyAccount from './ConnectShopifyAccount';
import { ESellerStore as Platform } from '../../../Types';
import ConnectOtherPlatformAccount from './ConnectOtherPlatformAccount';

export default function ConnectPlatformAccount({
  business,
  goForward,
  amzAccounts,
}) {
  const isAmazonSeller = business.sellerStore === Platform.amazon;
  const isShopifySeller = business.sellerStore === Platform.shopify;

  function renderStore() {
    if (isAmazonSeller) {
      return (
        <ConnectAmazonAccount
          amzAccounts={amzAccounts}
          goForward={goForward}
          business={business}
          lines={[]}
        />
      );
    } else if (isShopifySeller) {
      return <ConnectShopifyAccount goForward={goForward} />;
    } else {
      return <ConnectOtherPlatformAccount goForward={goForward} />;
    }
  }

  return renderStore();
}
